import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {isExternalStructureConsultant} from '@/features/agenda/utils'
import {useExternalStructureUserIds} from '@/features/users/hooks/useExternalStructureUserIds'
import {useMemo} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const AgendaFormDisabledOperationSchema = AgendaEventFieldsSchema.pick({
    patients: true,
    consultants: true,
    isGroupTreatment: true
})
type AgendaFormDisabledOperationSchema = z.infer<typeof AgendaFormDisabledOperationSchema>

export const useAgendaFormDisabledOperation = () => {
    const {control} = useFormContext<AgendaFormDisabledOperationSchema>()
    const patients = useWatch({control, name: 'patients'})
    const consultants = useWatch({control, name: 'consultants'})
    const isGroupTreatment = useWatch({control, name: 'isGroupTreatment'})
    const externalStructureUserIds = useExternalStructureUserIds()

    const areDisabledPatientRelatedFields = useMemo(() => {
        if (!patients) return false
        // Events on an external structure are deliberately not tied to a project, so the project-related
        // gating below does not apply to them
        if (consultants?.some(consultant => isExternalStructureConsultant(consultant, externalStructureUserIds))) {
            return false
        }
        return isGroupTreatment
            ? patients.some(patient => !patient.project?.id)
            : patients?.some(patient => !patient.project?.id && !patient.neuromuscularDiagnosisId)
    }, [patients, consultants, isGroupTreatment, externalStructureUserIds])

    return areDisabledPatientRelatedFields
}
